<!-- eslint-disable max-lines -->
<template>
    <div class="customers-introduction-manage">
        <Paper class="customers-introduction-manage-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <search-box ref="searchBox" :search-key="config.name" :fields="config.searchFields"
                        :showResetBtn="true" @search-change="introfuctionList.searchList" @elementChange="getAdvanceValue"
                        />
                </template>
                <template slot="header-button">
                    <lotsButton type="primary" size="mini" title="新增" @click="add" icon="el-icon-circle-plus-outline"
                        v-has="authorityCode.add">
                        <span class="icon iconfont">新增</span>
                    </lotsButton>
                    <lotsButton type="primary" size="mini" title="导出" @click="exportFile" v-has="authorityCode.export"
                        icon="el-icon-download">
                        <span class="icon iconfont">导出</span>
                    </lotsButton>
                    <lotsButton type="primary" size="mini" title="刷新" @click="refresh" plain>
                        <span class="icon iconfont icon-refresh"></span>
                    </lotsButton>
                    <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                        <el-button icon="iconfont icon-list_install" type="primary" size="mini" :title="'列配置'"
                            @click="showColumnConfigDialog" plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <table-box class="prescreen" v-loading="introfuctionList.tableLoading" :selection="config.selection"
                        :control="false" :columns="config.columns" :height="tableHeight"
                        :tableData="introfuctionList.totalData" :actions="config.actions" :editDisableRule="() => false"
                        :allowRowClick="false" @action-click="actionClick" :rows="introfuctionList.totalData"
                        @selection-change="handleSelectedRow" @row-dblclick="(row) => rowDBclick(row)">
                        <template v-slot:col-append="{ col, row }">
                            <div v-if="col.prop === 'billCode'">
                                <span size="mini" type="text" :title="row.billCode">{{ row.billCode || '' }}</span>
                            </div>
                            <div v-else-if="col.prop === 'routeCodes'">
                                <span>{{ getValByKey(row.routeCodes) || '' }}</span>
                            </div>
                        </template>
                    </table-box>
                </template>
                <template slot="footer">
                    <lots-pagination @size-change="introfuctionList.sizeChange"
                        :current-page.sync="introfuctionList.pageNo" @current-change="introfuctionList.pageChange"
                        size="small" layout="total, sizes, prev, pager, next, jumper"
                        :total="introfuctionList.pageTotal" />
                </template>
            </list-layout-paper>
            <column-config :pageID="config.name" :initColumns="config.columns" ref="otpColumnConfig"
                @header-change="config.columns = $event" />
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, computed, watch, getCurrentInstance, onMounted } from '@vue/composition-api';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import Paper from '@/components/core/Paper';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import columnConfig from '@/components/lots/columnConfig/Index';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import {
    getCustomerIntroductionPage, deleteCustomerIntroduction, exportCustomerIntroduction
} from '@mdm/api/customer/customerIntroduction.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { tableConfig } from './config.js';
import { Message, MessageBox } from 'element-ui';
import { dictWithUrl } from '@/components/lots/api';
import _ from 'lodash';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';

export default {
    name: 'customerIntroduction',
    components: {
        lotsPagination,
        tableBox,
        Paper,
        listLayoutPaper,
        searchBox,
        lotsButton,
        columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.customerIntroduction);
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        // const refs = setupContext.refs;
        const config = reactive(_.cloneDeep(tableConfig));
        const advanceDialogRef = ref(null);
        const isDisableBtn = ref(false);
        const saveLoading = ref(false);
        const activeTabs = ref('theList');
        class OverseasListClass extends AdvanceListClass {
            beforeGetList(condition) {
                delete condition.customerNames;
                delete condition.customerCodes;
                condition.orderBy = 'create_time';
                condition.orderByType = 'desc';
                return condition;
            };
            afterGetList(res) {
                if (res && res.list) {
                    introfuctionList.pageTotal.value = res.totalCount;
                    introfuctionList.totalData.value = res.list || [];
                }
            };
        }
        const introfuctionList = new OverseasListClass({
            Api: {
                listApi: getCustomerIntroductionPage
            }
        });
        const newColumns = computed(() => {
            return config.columns;
        });
        const btnLoading = ref(false);
        const routeCodesList = ref({});
        const getDc = async () => {
            await dictWithUrl('SYS_ROUTE_TYPE').then(res => {
                if (res && +res.code === 0) {
                    const { SYS_ROUTE_TYPE = {} } = res.data;
                    const listStr = SYS_ROUTE_TYPE;
                    routeCodesList.value = listStr || {};
                }
            });
        };
        const getValByKey = (keys = []) => {
            const keyVals = [];
            if (keys.length && routeCodesList.value) {
                for (let i = 0; i < keys.length; i++) {
                    keyVals.push(routeCodesList.value[keys[i]]);
                }
            }
            return keyVals.join(',');
        };
        const getAdvanceValue = ({ column, searchData }) => {
            if (column.value === 'customerName') {
                searchData.customerCodeList = searchData.customerNames ? searchData.customerCodes.split(',') : [];
            }
        };
        const selections = ref([]); // 选中的行数组
        const handleSelectedRow = (selection) => {
            selections.value = selection;
        };
        const refresh = () => {
            // 刷新
            introfuctionList.getList();
        };
        const add = () => {
            // 新增
            ctx.$router.push({
                name: 'customerIntroductionChangeFlow',
                query: {
                    type: 'add'
                }
            });
        };
        // 工具函数：转excelTitle对象
        const toExcelTitle = (item) => ({
            name: item.name,
            property: item.property
        });
        const exportFile = async () => {
            // 导出
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = introfuctionList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            const excelFileList = otherUtils.sortColumnsByFixed(config.columns)?.filter(it => it.property !== 'file');
            // 最新格式化导出
            const excelTitleList = excelFileList?.map(toExcelTitle);
            const params = {
                ...newData,
                orderBy: 'create_time',
                orderByType: 'desc',
                deleteFlag: 0,
                excelTitleList
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            exportCustomerIntroduction(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { });
        };
        const otpColumnConfig = ref(null);
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };
        const actionClick = (event, row, index) => {
            if (event === 'delete') {
                // 删除
                selections.value[0] = row;
                handleDelStatus();
            } else {
                // 审批/详情
                ctx.$router.push({
                    name: 'customerIntroductionChangeFlow',
                    query: {
                        // customerChangeType: type,
                        billCode: row.billCode,
                        customerCode: row.customerCode,
                        id: row.id,
                        type: event
                    }
                });
            }
        };
        const holePageLoading = ref(false);
        const rowDBclick = (row) => {
            actionClick('update', row);
        };
        const handleDelStatus = () => {
            if (!selections.value.length) {
                return Message.warning('请选择一条数据进行操作');
            };
            if (selections.value.find(it => +it.approvalStatus !== 1)) {
                selections.value = [];
                return Message.warning('客户引入申请单已关联流程，禁止删除');
            }
            MessageBox.confirm(`确认删除当前选择的数据？`, `提示：`, {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = selections.value.map(it => it.id);
                deleteCustomerIntroduction({ id: params.join(',') }).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('删除成功');
                    }
                }).finally(() => {
                    selections.value = [];
                    introfuctionList.getList();
                });
            }).catch(() => { introfuctionList.getList(); });
        };
        onMounted(async () => {
            // dictDatas.value = await otherUtils.getDictDataList(config.tableData.columns);
            const queryParams = {
                customerCodeList: []
            };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
            await getDc();
        });
        return {
            config,
            introfuctionList,
            advanceDialogRef,
            otpColumnConfig,
            btnLoading,
            handleSelectedRow,
            isDisableBtn,
            saveLoading,
            authorityCode,
            newColumns,
            handleDelStatus,
            actionClick,
            rowDBclick,
            getValByKey,
            routeCodesList,
            add,
            exportFile,
            refresh,
            showColumnConfigDialog,
            holePageLoading,
            activeTabs,
            getAdvanceValue
        };
    }
};
</script>

<style lang="less">
.customers-introduction-manage {
    width: 100%;

    .customers-introduction-manage-paper {
        height: 100%;
    }

    .list-layout-wrapper {
        height: 100%;
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.customers-introduction-manage-paper {
        padding: 0px 0px 0px;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }

}
</style>
